var exports = {
  "K2": "PricingGrid.module__gridWrapper___TVIwYj",
  "Vg": "PricingGrid.module__grid___TVIwYj",
  "mS": "PricingGrid.module__gridTwoColumns___TVIwYj" + " " + "PricingGrid.module__grid___TVIwYj",
};

module.exports = exports;
